import React from "react";

import { DisplayCtaBlock as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ANTONIO_URL, TYPEKIT_URL } from "../../utils/groups";

import hh from "../../styles/happy-hour.module.scss";
import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const DisplayCtaBlock = (props: Props) => {
    const value = props.value;
    if (!value.heading) {
        return null;
    }
    const link = value.link?.url ? value.link : null;
    return (
        <section
            className={concatClassNames([
                hh.tokens,
                value.background === "none" ? hh.page : hh.cream,
                styles.section,
            ])}
        >
            <link rel="stylesheet" href={TYPEKIT_URL} precedence="default" />
            <link rel="stylesheet" href={ANTONIO_URL} precedence="default" />
            <div className={hh.container}>
                <h2 className={concatClassNames([hh.title, styles.heading])}>
                    {value.heading}
                </h2>
                {link && (
                    <a
                        className={concatClassNames([hh.cta, styles.cta])}
                        href={link.url ?? undefined}
                    >
                        {link.display_name || link.url}
                    </a>
                )}
            </div>
        </section>
    );
};
